import React, {useEffect} from 'react';
import useQuery from "../../../cmp/hooks/useQuery";
import {post} from "../../../../api";
import Spinner from "../../../cmp/Spinner";
import { useNavigate } from "react-router-dom";
function PaypalOnCallback(){
    const {token, payerId, plan_id, subscription_id} = useQuery()
    const navigate = useNavigate();
    useEffect(()=>{
        if(plan_id && (token|| subscription_id)){
            post('/paymentplans/activate', {
                payment_gateway:'paypal',
                plan_id,
                data:{
                    token,
                    subscription_id,
                    payerId,
                }
            }).then((data) => {
                if (data.success) {
                    window.location = "/";
                } else {
                    navigate("/choose_plan",{replace:true})
                }
            }).catch((e) => {
                navigate("/choose_plan",{replace:true})
            })
        }
    },[token, payerId, plan_id, subscription_id])

    return <div className="d-flex min-vh-100 align-items-center justify-content-center">
        <Spinner size={"lg"}/>
    </div>;
}

export default PaypalOnCallback
